module.exports = __webpack_public_path__ + "img/sym1.38b4ba67.png";